// The day-granular scope for the KPI and chart endpoints. They bucket by
// calendar day, so they take the calendar-date window (`dateFrom`/`dateTo`)
// plus the browser `timezone` that resolves those days to instants server-side.
// The Pages-to-Review endpoints use a different, absolute form — see
// `discoverabilityPagesScope.ts`.
export type DiscoverabilityDayScope = {
  dateFrom: string;
  dateTo: string;
  crawlers?: string[];
  domain?: string;
  timezone?: string;
};

// fetchBaseQuery's URLSearchParams default joins arrays with commas, but the
// REST API's class-validator DTO expects list params as repeated query params
// (`crawlers=a&crawlers=b`). Serialize the scope explicitly so each list value
// becomes its own param.
export function appendDayScopeParams(
  search: URLSearchParams,
  scope: DiscoverabilityDayScope
): void {
  search.append('dateFrom', scope.dateFrom);
  search.append('dateTo', scope.dateTo);
  if (scope.crawlers) {
    scope.crawlers.forEach((crawler) => search.append('crawlers', crawler));
  }
  if (scope.domain) search.append('domain', scope.domain);
  if (scope.timezone) search.append('timezone', scope.timezone);
}
